import { Path } from '@/main/router/routerPath';

import { NAME } from './constants';
import List from './List.vue';

export const router = new Path(NAME, { List });
